module.exports = __webpack_public_path__ + "95d291390e25456af471d953bea62931.svg";